import React from 'react'
import Layout from 'features/layout/components/Layout'
import StaticPage from '../components/StaticPage'

const StaticPagePage = (props) => {
  return (
    <Layout>
      <StaticPage />
    </Layout>
  )
}

export default StaticPagePage
